import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-carrier-ineligible-warning',
  templateUrl: './carrier-ineligible-warning.component.html',
  styleUrls: ['./carrier-ineligible-warning.component.scss'],
})
export class CarrierIneligibleWarningComponent {}
